import { makeAutoObservable, runInAction } from "mobx";

export default class userStore {
  user = [];

  constructor() {
    makeAutoObservable(this);
  }

  setData = (data) => {
    this.user = [];
    runInAction(() => {
      this.user = data;
    });
  };

  deleteUser = (id) => {
    let objIndex = this.user.findIndex((user => user.id == id));
    if(objIndex !== -1) {
      this.user[objIndex].isActive = false;
    }
  };
}
